// Open House — the services the new Post a Project page posts: book writing,
// the paid sample, editing and bundles. Each brings its steps, its defaults,
// its price rail, where its submit issues land and its posted text; a bundle
// also brings its answer cascade and how a resumed draft fills its answers.
// The page starts on ?service=writing|sample|editing|bundle; a resumed draft
// opens on its own service. Anything else starts book writing.

import { DEFAULTS, ISSUE_ALIASES, openHouseSteps, railFor } from "./bookWritingSteps"
import { SAMPLE_ALIASES, SAMPLE_DEFAULTS, sampleRail, sampleSteps } from "./sampleSteps"
import { EDITING_ALIASES, EDITING_DEFAULTS, editingRail, editingSteps } from "./editingSteps"
import { BUNDLE_ALIASES, BUNDLE_DEFAULTS, bundleCascade, bundlePosting, bundleRail, bundleSteps } from "./bundleSteps"
import { WORDING } from "./wording"
import * as options from "@/lib/post/options"
import { BUNDLE_COMPOSITION } from "@/lib/post/bundle"

export const SERVICES = {
  book_writing: {
    key: "book_writing", defaults: DEFAULTS, steps: openHouseSteps, rail: railFor,
    aliases: ISSUE_ALIASES, postedBody: WORDING.postedBody,
  },
  sample: {
    key: "sample", defaults: SAMPLE_DEFAULTS, steps: sampleSteps, rail: sampleRail,
    aliases: SAMPLE_ALIASES, postedBody: WORDING.postedBody,
  },
  editing: {
    key: "editing", defaults: EDITING_DEFAULTS, steps: editingSteps, rail: editingRail,
    aliases: EDITING_ALIASES, postedBody: WORDING.postedEditingBody,
  },
  bundle: {
    key: "bundle", defaults: BUNDLE_DEFAULTS, steps: bundleSteps, rail: bundleRail,
    aliases: BUNDLE_ALIASES, postedBody: WORDING.postedBody, cascade: bundleCascade, fromDraft: bundlePosting,
  },
}

const REQUESTED = {
  writing: "book_writing", book_writing: "book_writing", sample: "sample", editing: "editing", bundle: "bundle",
}

export const serviceOf = (key) => (Object.hasOwn(SERVICES, key) ? SERVICES[key] : SERVICES.book_writing)

// The service a new page starts on, from its query string.
export function requestedService(search) {
  const key = new URLSearchParams(search || "").get("service")
  return key && Object.hasOwn(REQUESTED, key) ? REQUESTED[key] : "book_writing"
}

// The step context every Open House page drives its steps with: today's
// self-managed posting, one service, the catalog's prices and the account's flags.
export function postingCtx(catalog, service, bundleTier) {
  return {
    insider: catalog.insider,
    canUseAi: catalog.canUseAi,
    canPostNarration: catalog.canPostNarration,
    managedServices: false,
    outlinePrices: catalog.outlinePrices,
    rates: catalog.rates,
    managedTier: "self_managed",
    selected: [service],
    bundle: service === "bundle",
    bundleForceFiction: service === "bundle" && !!BUNDLE_COMPOSITION[bundleTier]?.forceFiction,
    bundles: catalog.bundles,
    options,
  }
}
